import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";
import api from "../../services/instance";

export const VerifyOtpAPI = createAsyncThunk(
    "VerifyOtpAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.verifyOtp(), data)
            // if (response.status === 200) {
            //     toast.success(response.data.message);
            // } else {
            //     toast.error("Something went wrong. Please try again.");
            // }
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const VerifyEmailAddressAPI = createAsyncThunk(
    "VerifyEmailAddressAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.verifyEmailAddress(id))
            if (response.status === 200) {
                toast.success(response.data.message);
            } else {
                toast.error("Something went wrong. Please try again.");
            }
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
}

const VerifyOTP = createSlice({
    initialState,
    name: "VerifyOTP",
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(VerifyOtpAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(VerifyOtpAPI.fulfilled, (state, action) => {
            state.loading = false
        })

        builder.addCase(VerifyOtpAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = VerifyOTP.actions
export default VerifyOTP.reducer